module.exports = __webpack_public_path__ + "static/media/landingImage2.dda000eb.png";